import { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

const MessageList = ({ 
  messages, 
  isTyping, 
  primaryColor, 
  secondaryColor, 
  getContrastColor,
  isMobile,
  agentName,
  agentLogo,
  chatState
}) => {
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  // Detecta se mensagem é a última da sequência do mesmo tipo
  const isLastInSequence = (index) => {
    if (index === messages.length - 1) return true;
    return messages[index].type !== messages[index + 1]?.type;
  };

  return (
    <div 
      ref={messagesContainerRef}
      className={`${isMobile ? 'flex-1' : 'h-96'} overflow-y-auto p-4 space-y-2 bg-gray-50`}
    >
      {messages.map((message, index) => (
        <MessageBubble
          key={message.id}
          message={message}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          getContrastColor={getContrastColor}
          isLastInSequence={isLastInSequence(index)}
          agentName={agentName}
          agentLogo={agentLogo}
          chatState={chatState}
        />
      ))}
      
      {isTyping && (
        <TypingIndicator 
          primaryColor={primaryColor} 
          getContrastColor={getContrastColor}
        />
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;